import { useStore } from "@/store";
import { AuthActionTypes } from "@/store/auth/actions";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Landing",
    beforeEnter: (to, from, next) => {
      const store = useStore();
      if (store.getters.isAuthenticated) {
        const groups = store.getters.getGroups;
        if (groups.includes("Admin") || groups.includes("Worker"))
          next({ name: "Admin" });
        else next({ name: "MyBarrels" });
        return;
      }
      next();
    },
    component: () =>
      import(/* webpackChunkName: "landing" */ "../views/Landing.vue"),
  },
  {
    path: "/landing",
    name: "LandingPage",
    component: () => import(/* webpackChunkName: "landing" */ "../views/Landing.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/logout",
    name: "Logout",
    beforeEnter: (to, from, next) => {
      const store = useStore();
      if (store.getters.isAuthenticated) {
        (async () => {
          await store.dispatch(AuthActionTypes.Logout, undefined);
        })();
      }
      next({ name: "Login" });
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/confirmaccount/:email/:code?",
    name: "ConfirmAccount",
    component: () =>
      import(
        /* webpackChunkName: "confirmaccount" */ "../views/ConfirmAccount.vue"
      ),
  },
  {
    path: "/signup",
    name: "Signup",
    component: () =>
      import(/* webpackChunkName: "signup" */ "../views/Signup.vue"),
  },
  {
    path: "/mybarrels",
    name: "MyBarrels",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "mybarrels" */ "../views/MyBarrels.vue"),
  },
  {
    path: "/receipt/:paymentType/:barrelId/:transactionId",
    name: "Receipt",
    component: () =>
      import(
        /* webpackChunkName: "receipt" */ "../views/OrderConfirmation.vue"
      ),
  },
  {
    path: "/order/:barrelId?",
    name: "Order",
    meta: {
      requiresAuth: false,
    },
    component: () =>
      import(/* webpackChunkName: "orderbarrel" */ "../views/OrderBarrel.vue"),
  },
  {
    path: "/details/:barrelId",
    name: "Details",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "barreldetails" */ "../views/BarrelDetails.vue"
      ),
  },
  {
    path: "/consignee/:barrelId",
    name: "Consignee",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "barreldetails" */ "../views/Consignee.vue"),
  },
  {
    path: "/Manage/:barrelId",
    name: "Manage",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "managebarrel" */ "../views/ManageBarrel.vue"
      ),
  },
  {
    path: "/customer/:pybNumber",
    name: "ViewCustomer",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "viewcustomer" */ "../views/ViewCustomer.vue"
      ),
  },
  {
    path: "/email/:emailId",
    name: "ViewEmail",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "viewemail" */ "../views/ViewEmail.vue"
      ),
  },
  {
    path: "/admin",
    name: "Admin",
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/Admin.vue"),
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: () =>
      import(
        /* webpackChunkName: "forgetpassword" */ "../views/ForgotPassword.vue"
      ),
  },
  {
    path: "/resetpassword/:code?",
    name: "ResetPassword",
    component: () =>
      import(
        /* webpackChunkName: "resetpassword" */ "../views/ResetPassword.vue"
      ),
  },
  {
    path: "/document/:logicalBarrelId",
    name: "ConsigneeDocumentUploadLogin",
    component: () => import(/* webpackChunkName: "consigneeDocumentUploadLogin" */"../views/ConsigneeDocumentUploadLogin.vue"),
  },
  {
    path: "/upload",
    name: "PYBUserUpload",
    component: () => import(/* webpackChunkName: "pybUserUpload" */"../views/PYBUserUpload.vue"),
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: () => import(/* webpackChunkName: "contactus" */"@/views/Contact.vue")
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import(/* webpackChunkName: "faq" */"../views/Faq.vue")
  },
  {
    path: "/:catchAll(.*)",
    name: "PageNotFound",
    component: () => import(/* webpackChunkName: "pageNotFound" */"../views/PageNotFound.vue")
  }

];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const store = useStore();
    if (!(await store.dispatch(AuthActionTypes.IsAuthenticated, undefined))) {
      next({ name: "Login" });
    } else {
      next();
    }
  } else {
    next();
  }
  if (to.matched.some((record) => record.meta.requiresAdmin)) {
    const store = useStore();
    const groups = store.getters.getGroups;
    if (!(groups.includes("Admin") || groups.includes("Worker"))) {
      next({ name: "MyBarrels" });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
